export default "__VITE_PUBLIC_ASSET__6f88f337__"